export default __webpack_public_path__ + "static/media/cotidiano.c805c9cf.svg";